<template>
    <div class="slider-card"
             @mouseleave="isMouseOver = false"
             @mouseover="handlerMouseOver"
    >
        <DefLabels :result="result.labels" />
        <div class="slider-card__header" @click="openProductPage"
             :style="isMouseOver && `background-image: url('${ result.pictures[ 1 ] && result.pictures[ 1 ].src }')`"
        >
            <a :href="result.detailPage" :style="isMouseOver && 'visibility: hidden;'">
                <DefImg
                    v-if="result.picture"
                    :result="result.picture"
                    :loadImageNow="result.isSmallBasket"
                />
            </a>
        </div>
        <div class="slider-card__footer">
            <a :href="result.detailPage" class="slider-card__name">{{ result.printName }}</a>
            <div v-if="result.price" class="slider-card__prices">
                <DefPriceOld v-if="result.price.printPriceOld">{{ result.price.printPriceOld }}</DefPriceOld>
                <DefPrice v-if="result.price.printPrice">{{ result.price.printPrice }}</DefPrice>
            </div>
<!--            <div @click="test">-->
<!--                test-->
<!--            </div>-->
<!--            <div class="add-item def-bt reserve-bt">add</div>-->
            <DefBuy :result="result" v-if="!result.isByComplect">
                <template #notAvailable>
                    <!-- @todo move to messgaes and get from it-->
                    <span>{{ 'Немає в наявності' }}</span>
                </template>
                {{ basketMessages.buy }}
            </DefBuy>
            <div v-else>
              <button type="button" class="def-buy-component" v-if="result.isSmallBasket" @click="addToBasket(result.id)">{{messages.setBuyButton}}</button>
              <div class="custom-control custom-checkbox" v-else>
                <input :id="'buy-complect-' + result.id" type="checkbox" class="custom-control-input" :value="result.id">
                <label :for="'buy-complect-' + result.id" class="custom-control-label"></label>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import DefLabels from "../../Def/DefLabels/DefLabels.vue";
import DefImg from "../../Def/DefImg/DefImg.vue";
import DefPriceOld from "../../Def/DefPriceOld/DefPriceOld.vue";
import DefPrice from "../../Def/DefPrice/DefPrice.vue";
import DefBuy from "../../Def/DefBuy/DefBuy.vue";
// import ECommerceSend from "../../../utils/ECommerceSend";
export default {
    name: 'SliderCard',
  components: {DefBuy, DefPrice, DefPriceOld, DefImg, DefLabels},
    props: ['result', 'showBuyButton', 'messages'],
    data() {
        return {
            isMouseOver: false,
        }
    },
    computed: {
        ...mapState({
            basketMessages: ({ basket }) => basket.data.messages,
        }),
    },
    methods: {
        handlerMouseOver() {
            if (this.screenWidth >= 992) this.isMouseOver = true;
        },
        openProductPage() {
            location.href = this.result.detailPage;
        },
        addToBasket(productId) {
          this.$emit('addToBasket', productId);
        }

        // eCommerceSend(){
        //     ECommerceSend.click(this.result.dataLayerProduct);
        // },
    }
}
</script>

<style lang="scss" scoped>
.slider-card{
    display: flex;
    flex-direction: column;
    background-color: #fff;
    height: 100%;
    &__header{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 36px 34px 32px;
        position: relative;
        margin-bottom: 7px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% auto;
        cursor: pointer;
        @include point-md{
            padding: 24px 22px 26px;
        }
        @include point-lg{
            padding: 26px;
        }
    }
    &__footer{
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-grow: 1;
        margin-bottom: 22px;
        .custom-control {
          display: block;
          min-height: 1.5rem;
          position: relative;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          z-index: 1;
          padding-left: 0;
        }
        .custom-control-input {
          height: 1.25rem;
          opacity: 0;
          position: absolute;
          width: 1rem;
          z-index: -1;
        }
        .custom-control-label {
          cursor: pointer;
          min-height: 30px;
          padding-left: 30px;
          margin-bottom: 0;
          text-align: center;
        }
        .custom-control-label:before {
          border: 1px solid #adadad;
          background-color: transparent !important;
          border-radius: 50% !important;
          left: 0;
          padding-left: 0;
          box-shadow: none;
          width: 24px;
          height: 24px;
        }
        .custom-control-label:after {
          content:"";
          height:8px;
          opacity:0;
          position:absolute;
          top:7px;
          width:13px;
          display: block;
          border-bottom-width: 2px;
          border-bottom-style: solid;
          border-bottom-color: rgb(15, 15, 16);
          border-left-width: 2px;
          border-left-style: solid;
          border-left-color: rgb(15, 15, 16);
          border-image-outset: 0;
          border-image-repeat: stretch;
          border-image-slice: 100%;
          border-image-source: none;
          border-image-width: 1;
        }
        .custom-control-input:checked + .custom-control-label:before {
          background-color: #0f0f10 !important;
          border: 1px solid #979797;
        }
        .custom-control-input:checked + .custom-control-label:after {
          background-image: none;
          border-color: #fff;
          transform: scale(1) rotate(-45deg);
          font-size: 13px;
          opacity: 1;
          top: 10px;
          left: 6px;
        }
        @include point-md{
            margin-bottom: 16px;
        }
        @include point-lg{
            margin-bottom: 19px;
        }
    }
    &__name{
        color: #3b3d40;
        /*font-weight: 600;*/
        font-size: rem(16);
        text-align: center;
        letter-spacing: 0.01em;
        /*text-transform: uppercase;*/
        /*margin-bottom: 8px;*/
        max-height: 22px;
        overflow: hidden;
    }
    :deep(.def-img){
        width: 100%;
    }
    :deep(.def-price-old){
        margin-left: 10px;
    }
    :deep(.def-favourite){
        position: absolute;
        top: 12px;
        right: 12px;
    }
    :deep(.def-colors-small){
        margin-bottom: 12px;
    }

    ::v-deep{
        .def-buy-component{
            margin-top: 10px;
            color: #030304;
        }
        .def-labels{
            position: absolute;
            z-index: 1;
            right: 20px;
        }
    }
  .def-buy-component{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    background-color: transparent;
    border: 2px solid #000;
    font-weight: 600;
    font-size: rem(10);
    line-height: 100%;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    transition: .2s linear background-color;
    padding: 0 15px;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    border-radius: rem(8);
    &:hover{
      background-color: #3c3d41;
      color: white;
    }
  }
}
.smollBasket .buy-complect-slider .slider-card__footer {
  margin-bottom: 0;
}
</style>